<template>
	<div class="tags" v-if="showTags">
		<ul>
			<li class="tags-li" v-for="(item, index) in tagsList"
				:class="[isActive(item.path) ? 'active' : '', isActive(item.path) ? `${theme}` : ' ']" :key="index">
				<!-- <li class="tags-li" v-for="(item, index) in tagsList" :class="[{ active: isActive(item.path) }]" :key="index"> -->
				<router-link :to="item.path" class="tags-li-title">{{ item.title }}</router-link>
				<span class="tags-li-icon" @click="closeTags(index)">
						<svg viewBox="0 0 1024 1024" width="12" height="12" fill="currentColor">
							<path d="M512 451.669333L293.376 233.045333a21.333333 21.333333 0 0 0-30.165333 0l-0.021334 0.021334a21.333333 21.333333 0 0 0 0 30.165333L482.090667 482.090667 263.168 701.013333a21.333333 21.333333 0 0 0 0 30.165334l0.021333 0.021333a21.333333 21.333333 0 0 0 30.165334 0L512 512.256l218.624 218.624a21.333333 21.333333 0 0 0 30.165333 0l0.021334-0.021333a21.333333 21.333333 0 0 0 0-30.165334L542.186667 482.090667 761.088 263.189333a21.333333 21.333333 0 0 0 0-30.165333l-0.021333-0.021334a21.333333 21.333333 0 0 0-30.165334 0L512 451.669333z"/>
						</svg>
					</span>
			</li>
		</ul>
		<div class="tags-close-box">
			<el-dropdown @command="handleTags">
				<el-button size="small" type="primary" :class="[theme]">
					标签选项
					<i class="el-icon-arrow-down el-icon--right"></i>
				</el-button>
				<template #dropdown>
					<el-dropdown-menu size="small">
						<el-dropdown-item command="other">关闭其他</el-dropdown-item>
						<el-dropdown-item command="all">关闭所有</el-dropdown-item>
					</el-dropdown-menu>
				</template>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				theme: localStorage.getItem('theme')
			};
		},
		computed: {
			tagsList() {
				return this.$store.state.tagsList;
			},
			showTags() {
				return this.tagsList.length > 0;
			}
		},
		methods: {
			isActive(path) {
				return path === this.$route.fullPath;
			},
			// 关闭单个标签
			closeTags(index) {
				const delItem = this.tagsList[index];
				this.$store.commit('delTagsItem', { index });
				const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			// 关闭全部标签
			closeAll() {
				this.$store.commit('clearTags');
				this.$router.push('/');
			},
			// 关闭其他标签
			closeOther() {
				const curItem = this.tagsList.filter(item => {
					return item.path === this.$route.fullPath;
				});
				this.$store.commit('closeTagsOther', curItem);
			},
			// 设置标签
			setTags(route) {
				const isExist = this.tagsList.some(item => {
					return item.path === route.fullPath;
				});
				if (!isExist) {
					if (this.tagsList.length >= 88) {
						this.$store.commit('delTagsItem', { index: 0 });
					}
					this.$store.commit('setTagsItem', {
						name: route.name,
						title: route.meta.title,
						path: route.fullPath
					});
				}
			},
			handleTags(command) {
				command === 'other' ? this.closeOther() : this.closeAll();
			}
		},
		watch: {
			$route(newValue) {
				this.setTags(newValue);
			}
		},
		created() {
			this.setTags(this.$route);
			// 关闭当前页面的标签页
			// this.$store.commit("closeCurrentTag", {
			//     $router: this.$router,
			//     $route: this.$route
			// });
		}
	};
</script>

<style>
	.tags {
		position: relative;
		overflow: visible;
		padding-right: 120px;
		min-height: 29px;
	}

	.tags ul {
		box-sizing: border-box;
		width: 100%;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 4px;
		padding: 2px 0;
	}

	.tags-li {
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		margin: 0 4px;
		border-radius: 3px;
		font-size: 12px;
		cursor: pointer;
		height: 26px;
		border: 1px solid #e9eaec;
		background: #fff;
		padding: 0 18px 0 10px;
		color: #666;
		transition: all 0.3s ease-in;
		flex-shrink: 0;
	}

	.tags-li:not(.active):hover {
		background: #f8f8f8;
	}

	.tags-li.active {
		color: #fff;
	}

	.tags-li-title {
		max-width: 80px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		color: #666;
		text-decoration: none;
		line-height: 1;
		text-align: center;
	}

	.tags-li.active .tags-li-title {
		color: #fff;
	}

	.tags-li-icon {
		position: absolute;
		top: 50%;
		right: 2px;
		transform: translateY(-50%);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 16px;
		height: 16px;
		border-radius: 3px;
		cursor: pointer;
		color: #aaa;
		background: transparent;
		transition: all 0.2s;
		z-index: 1;
	}

	.tags-li-icon:hover {
		color: #ff4d4f;
		background: rgba(255, 77, 79, 0.15);
	}

	.tags-li.active .tags-li-icon {
		color: rgba(255, 255, 255, 0.85);
	}

	.tags-li.active .tags-li-icon:hover {
		color: #fff;
		background: rgba(255, 255, 255, 0.25);
	}

	.tags-close-box {
		position: absolute;
		right: 0;
		top: 2px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 10px;
		background: #fff;
		border-radius: 3px;
		z-index: 10;
	}

	/deep/ .el-button--primary {
		background-color: #4f7afd;
		border: 1px solid #4f7afd;
	}
</style>